import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel } from "./ui/dropdown-menu";

export function useDeityGroups() {
  const [groups, setGroups] = useState([]);
  useEffect(() => {
    api.get("/deities").then((r) => {
      const map = new Map();
      r.data.items.forEach((d) => map.set(d.category, [...(map.get(d.category) || []), d]));
      setGroups([...map.entries()]);
    }).catch(() => {});
  }, []);
  return groups;
}

export default function DeitiesMenu() {
  const groups = useDeityGroups();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="nav-deities-menu" className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-[#1F1412] hover:text-[#4A0E17] transition-sacred">
          Gods & Goddesses <ChevronDown className="w-3.5 h-3.5" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="bg-[#FFFDF9] border-[#D4AF37]/40 w-[min(92vw,760px)] max-h-[70vh] overflow-y-auto p-4">
        <DropdownMenuItem asChild><Link to="/deities" data-testid="nav-deities-all" className="font-semibold text-[#E65100]">See all gods & goddesses →</Link></DropdownMenuItem>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-x-4 mt-2">
          {groups.map(([cat, list]) => (
            <div key={cat} className="mt-2">
              <DropdownMenuLabel className="overline !text-[0.6rem] px-2">{cat}</DropdownMenuLabel>
              {list.map((d) => (
                <DropdownMenuItem key={d.slug} asChild>
                  <Link to={`/deities/${d.slug}`} data-testid={`nav-deity-${d.slug}`} className="text-sm text-[#1F1412] cursor-pointer">{d.name}</Link>
                </DropdownMenuItem>
              ))}
            </div>
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
